import React from 'react';

import { string, shape, bool, node } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';

import './Label.scss';

export default class Label extends BaseComponent {
  render() {
    const {
      children,
      className,
      htmlFor,
      invalid,
      required,
      subtext
    } = this.props;

    const containerClasses = ClassNames(
      'label',
      invalid && 'label--invalid',
      className
    );

    const labelClasses = ClassNames(
      'label__label',
      required && 'label__label--required'
    );

    return (
      <div className={containerClasses}>
        <label htmlFor={htmlFor} className={labelClasses}>
          {children}
        </label>
        {subtext && <p className="label__subtext">{subtext}</p>}
      </div>
    );
  }
}

Label.propTypes = {
  children: node.isRequired,
  className: string,
  htmlFor: string,
  id: string,
  invalid: bool,
  required: bool,
  style: shape({}),
  subtext: string
};

Label.defaultProps = {
  className: '',
  htmlFor: undefined,
  id: undefined,
  inline: false,
  invalid: false,
  required: false,
  style: {},
  subtext: undefined
};
